import { LCPMetricWithAttribution } from "web-vitals";

export const getLcpTime = (metric: LCPMetricWithAttribution) => {
    return metric.attribution.lcpEntry?.startTime || metric.attribution.lcpEntry?.renderTime || performance.now()
}

export const getMetricDateTime = (metricTime: number) => new Date(performance.timeOrigin + metricTime).toISOString();

export const waitForLoad = () => {
    return new Promise<void>((resolve) => {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            window.addEventListener('load', () => setTimeout(resolve, 100), { once: true });
        }
    });
};

export const isResourceEntry = (entry: PerformanceEntry): entry is PerformanceResourceTiming => {
    return entry.entryType === "resource";
};
